/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type employee_selfservice_CreateMyAbsenceRequestBody = {
    /**
     * Type of absence: VACATION, SICK, PERSONAL, TRAINING, COMP_TIME or OTHER.
     * ACCIDENT and CHILD_SICK cannot be requested: the employee reports them through
     * POST /api/v1/employee/me/absence-reports.
     */
    absence_type: employee_selfservice_CreateMyAbsenceRequestBody.absence_type;
    from_date: string;
    from_time?: string;
    full_day?: boolean;
    notes?: string;
    to_date: string;
    to_time?: string;
};
export namespace employee_selfservice_CreateMyAbsenceRequestBody {
    /**
     * Type of absence: VACATION, SICK, PERSONAL, TRAINING, COMP_TIME or OTHER.
     * ACCIDENT and CHILD_SICK cannot be requested: the employee reports them through
     * POST /api/v1/employee/me/absence-reports.
     */
    export enum absence_type {
        VACATION = 'VACATION',
        SICK = 'SICK',
        PERSONAL = 'PERSONAL',
        TRAINING = 'TRAINING',
        COMP_TIME = 'COMP_TIME',
        OTHER = 'OTHER',
    }
}

